import { action } from 'typesafe-actions';
import { asyncAction } from 'store/utils/promiseAction';
import {
  TripTypes,
  TripInterface,
  TripControl,
  MonitoringSettingsInterface,
} from './types';

// List Trips Detail
export const listTripsDetailRequest = (payload: {
  params?: object;
  recovers?: string;
  showLoading?: boolean;
}) => action(TripTypes.LIST_TRIPS_DETAIL_REQUEST, payload);

export const listTripsDetailSuccess = (payload: {
  tripDetailsList: TripInterface[];
  totalCount: number;
}) => action(TripTypes.LIST_TRIPS_DETAIL_SUCCESS, payload);

export const listTripsDetailFailure = () =>
  action(TripTypes.LIST_TRIPS_DETAIL_FAILURE);

// List Trips
export const listTripsRequest = (payload: {
  params?: object;
  recovers?: string;
  showLoading?: boolean;
  isCsvFull?: boolean;
}) => action(TripTypes.LIST_TRIPS_REQUEST, payload);

export const listTripsSuccess = (payload: {
  tripList: TripInterface[];
  tripListFull?: TripInterface[];
  loading?: boolean;
  totalCount: number;
  isCsvFull?: boolean;
}) => action(TripTypes.LIST_TRIPS_SUCCESS, payload);

export const listTripsFailure = () => action(TripTypes.LIST_TRIPS_FAILURE);

// Get Trip
export const getTripsRequest = (payload: object) =>
  asyncAction(TripTypes.GET_TRIPS_REQUEST, payload);

export const getTripsSuccess = (payload: { tripData: TripInterface }) =>
  action(TripTypes.GET_TRIPS_SUCCESS, payload);

export const getTripsFailure = () => action(TripTypes.GET_TRIPS_FAILURE);

// Trips PDF
export const tripsPDFRequest = (payload: { tripIds: string[] }) =>
  action(TripTypes.TRIPS_PDF_REQUEST, payload);

export const tripsPDFSuccess = () => action(TripTypes.TRIPS_PDF_SUCCESS);

export const tripsPDFFailure = () => action(TripTypes.TRIPS_PDF_FAILURE);

// Trips addPayment
export const tripsPaymentRequest = (payload: object) =>
  action(TripTypes.TRIPS_PAYMENT_REQUEST, payload);

export const tripsPaymentSuccess = () =>
  action(TripTypes.TRIPS_PAYMENT_SUCCESS);

export const tripsPaymentFailure = () =>
  action(TripTypes.TRIPS_PAYMENT_FAILURE);

// Trips addApproval
export const tripsApprovalRequest = (payload: object) =>
  action(TripTypes.TRIPS_APROVAL_REQUEST, payload);

export const tripsApprovalSuccess = () =>
  action(TripTypes.TRIPS_APROVAL_SUCCESS);

export const tripsApprovalFailure = () =>
  action(TripTypes.TRIPS_APROVAL_FAILURE);

// Trips Approval All
export const tripsApprovalAllRequest = (payload: object) =>
  action(TripTypes.TRIPS_APPROVAL_ALL_REQUEST, payload);

export const tripsApprovalAllSuccess = () =>
  action(TripTypes.TRIPS_APPROVAL_ALL_SUCCESS);

export const tripsApprovalAllFailure = () =>
  action(TripTypes.TRIPS_APPROVAL_ALL_FAILURE);

// Trips Report Html
export const tripReportHtmlRequest = (payload: { tripIds: string[] }) =>
  action(TripTypes.TRIP_REPORT_HTML_REQUEST, payload);

export const tripReportHtmlSuccess = (payload: { tripReportHtml: string }) =>
  action(TripTypes.TRIP_REPORT_HTML_SUCCESS, payload);

export const tripReportHtmlFailure = () =>
  action(TripTypes.TRIP_REPORT_HTML_FAILURE);

// Trip Report
export const tripReportRequest = (payload: object) =>
  action(TripTypes.TRIP_REPORT_REQUEST, payload);

export const tripReportSuccess = (payload: { tripReport: TripInterface[] }) =>
  action(TripTypes.TRIP_REPORT_SUCCESS, payload);

export const tripReportFailure = () => action(TripTypes.TRIP_REPORT_FAILURE);

// Trip -> Km Type
export const changeKmType = (payload: { kmType: string }) =>
  action(TripTypes.CHANGE_KM_TYPE, payload);

// Trip Update Control
export const tripUpdateControlRequest = (payload: object) =>
  action(TripTypes.TRIP_UPDATE_CONTROL_REQUEST, payload);
export const tripUpdateControlSuccess = (payload: {
  tripReportControl: TripControl;
}) => action(TripTypes.TRIP_UPDATE_CONTROL_SUCCESS, payload);
export const tripUpdateControlFailure = () =>
  action(TripTypes.TRIP_UPDATE_CONTROL_FAILURE);

// Trip Control Settings Get
export const tripControlSettingsGetRequest = (payload: object) =>
  action(TripTypes.TRIP_CONTROL_SETTINGS_REQUEST, payload);
export const tripControlSettingsGetSuccess = (payload: {
  tripControlSettingsData: TripControl;
}) => action(TripTypes.TRIP_CONTROL_SETTINGS_SUCCESS, payload);
export const tripControlSettingsGetFailure = () =>
  action(TripTypes.TRIP_CONTROL_SETTINGS_FAILURE);

// Trip Update Control
export const tripControlSettingsUpdateRequest = (payload: object) =>
  action(TripTypes.TRIP_CONTROL_SETTINGS_UPDATE_REQUEST, payload);
export const tripControlSettingsUpdateSuccess = (payload: {
  tripControlSettingsData: TripControl;
}) => action(TripTypes.TRIP_CONTROL_SETTINGS_UPDATE_SUCCESS, payload);
export const tripControlSettingsUpdateFailure = () =>
  action(TripTypes.TRIP_CONTROL_SETTINGS_UPDATE_FAILURE);

// Monitoring Settings List
export const monitoringSettingsListRequest = (payload: object) =>
  action(TripTypes.MONITORING_SETTINGS_REQUEST, payload);
export const monitoringSettingsListSuccess = (payload: {
  monitoringSettingsList: MonitoringSettingsInterface;
}) => action(TripTypes.MONITORING_SETTINGS_SUCCESS, payload);
export const monitoringSettingsListFailure = () =>
  action(TripTypes.MONITORING_SETTINGS_FAILURE);

// Trip Update Control
export const monitoringSettingsUpdateRequest = (payload: object) =>
  action(TripTypes.MONITORING_SETTINGS_UPDATE_REQUEST, payload);
export const monitoringSettingsUpdateSuccess = (payload: {
  monitoringSettingsList: MonitoringSettingsInterface;
}) => action(TripTypes.MONITORING_SETTINGS_UPDATE_SUCCESS, payload);
export const monitoringSettingsUpdateFailure = () =>
  action(TripTypes.MONITORING_SETTINGS_UPDATE_FAILURE);

// Ask Missing entries
export const tripAskMissingEntriesRequest = (payload: { id: string }) =>
  action(TripTypes.TRIP_ASK_MISSING_ENTRIES, payload);
